<template>
    <div :class="['mascot', `type${type}`, reverse && 'reverse']">
        <transition name="fade" appear>
            <div class="image" />
        </transition>
        <div class="bubbles">
            <SpeechBubble
                ref="bubble1"
                class="bubble1"
                speech-tail="right"
            >
                <slot name="bubble1" />
            </SpeechBubble>
            <SpeechBubble
                ref="bubble2"
                class="bubble2"
                background="light-blue"
            >
                <slot name="bubble2" />
            </SpeechBubble>
        </div>
    </div>
</template>

<script>
const {setTimeout} = globalThis;

export default {
    name: 'Mascot',
    props: {
        type: {
            type: Number,
            default: 1
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    mounted()
    {
        setTimeout(() => this.$refs.bubble1.show(), 300);
        if (this.$slots.bubble2)
        {
            setTimeout(() => this.$refs.bubble2.show(), 700);
        }
    }
};
</script>

<style lang="scss" src="./Mascot.scss" />
